export default __webpack_public_path__ + "static/media/Badge_green.f4904f12.svg";